<template>
  <div :class="classes" :style="{ '--spinner-color': color }" />
</template>

<script>
export default {
  name: 'Asd20Spinner',
  props: {
    color: { type: String, default: '' },
    size: {
      type: String,
      default: 'xs',
      validator: value => {
        // The value must match one of these strings
        return ['xs', 'sm', 'md', 'lg'].indexOf(value) !== -1
      },
    },
  },
  computed: {
    classes() {
      return ['asd20-spinner', `asd20-spinner--${this.size}`]
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_variables.scss';

$sizes: (
  xs: space(0.5),
  sm: space(0.75),
  md: space(1.5),
  lg: space(3),
  xl: space(4),
);

$thickness: 2px;
.asd20-spinner {
  --spinner-color: var(--color__accent);
  // margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border: $thickness solid transparent;
  border-radius: 50%;
  border-left-color: var(--spinner-color);
  border-bottom-color: var(--spinner-color);
  transform: translateZ(0);
  animation: asd20-spinner 0.75s infinite linear;
  &:after {
    content: '';
    position: absolute;
    top: -$thickness;
    left: -$thickness;
    right: -$thickness;
    bottom: -$thickness;
    border: $thickness solid var(--spinner-color);
    border-radius: 50%;
    opacity: 0.25;
  }
}

@each $key, $val in $sizes {
  .asd20-spinner--#{$key} {
    height: $val;
    width: $val;
  }
}

@keyframes asd20-spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
